"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_redux_1 = require("react-redux");
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
const utils_common_is_webview_1 = __importDefault(require("@gcloud-npm/utils.common.is-webview"));
const reducers_main_reducer_1 = require("@/bit/reducers/reducers.main-reducer");
const create_initial_object_1 = __importDefault(require("./create-initial-object"));
const utils_common_get_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-cookie"));
const get_geo_1 = __importDefault(require("./get-geo"));
const utils_page_get_optanon_cookie_info_1 = __importDefault(require("@gcloud-npm/utils.page.get-optanon-cookie-info"));
const get_eg_1 = __importDefault(require("./get-eg"));
const get_recom_1 = __importDefault(require("./get-recom"));
const getOptanonCookieInfoWebview = () => __awaiter(void 0, void 0, void 0, function* () {
    let optanon = (0, utils_common_get_cookie_1.default)("OptanonConsent");
    optanon = decodeURIComponent(optanon);
    let ad_storage = optanon && optanon.indexOf("C0004:1") !== -1 ? "granted" : "denied";
    let analytics_storage = optanon && optanon.indexOf("C0002:1") !== -1 ? "granted" : "denied";
    let ad_user_data = ad_storage;
    let ad_personalization = ad_storage;
    let retries = 10;
    let waitWB = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
        retries--;
        if (window.webviewBridge) {
            retries = -1;
            let status = yield window.webviewBridge.getAttStatus();
            if (status != null) {
                ({ status } = status);
                // cogemos el valorcito, sino me quedo los que ya
                ad_storage = status;
                analytics_storage = status;
                ad_user_data = status;
                ad_personalization = status;
            }
        }
        if (retries < 0) {
            clearInterval(waitWB);
        }
    }), 100);
    return {
        ad_storage,
        analytics_storage,
        ad_user_data,
        ad_personalization,
    };
});
class RouteHandler extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleRouteLanding = () => __awaiter(this, void 0, void 0, function* () {
            const { context, checkCPAndSetZones, setCpParams, setUserPqInfo, setUserLgInfo, setUserRecom, setContextData, isReactApp, } = this.props;
            const secureStorage = new utils_secure_local_storage_1.default();
            const persistedInfo = secureStorage.getItem("ts");
            // 1) Miramos estado cookies
            let { ad_storage, analytics_storage, ad_user_data, ad_personalization, } = {};
            if ((0, utils_common_is_webview_1.default)()) {
                ({
                    ad_storage,
                    analytics_storage,
                    ad_user_data,
                    ad_personalization
                } = yield getOptanonCookieInfoWebview());
            }
            else {
                ({
                    ad_storage,
                    analytics_storage,
                    ad_user_data,
                    ad_personalization
                } = (0, utils_page_get_optanon_cookie_info_1.default)());
            }
            // 2) Creamos context para main en redux y enviamos a GA
            (0, create_initial_object_1.default)({
                context,
                setUserPqInfo,
                setUserLgInfo,
                setContextData,
                setUserRecom,
                ad_storage,
                analytics_storage,
                ad_user_data,
                ad_personalization,
                isReactApp
            });
            // 3) Persistimos geo
            (0, get_geo_1.default)({ persistedInfo, checkCPAndSetZones, setCpParams });
            // 4) Persistimos getRecom
            (0, get_recom_1.default)({ persistedInfo, setUserRecom, ad_storage, analytics_storage, setUserPqInfo });
            // 5) Persistimos getEg
            (0, get_eg_1.default)({ persistedInfo });
        });
        RouteHandler.__singletonRef = this;
    }
    componentDidMount() {
        const { isReactApp } = this.props;
        if (!isReactApp) {
            this.handleRouteLanding();
        }
    }
    render() {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
RouteHandler.loadPage = () => {
    RouteHandler.__singletonRef.handleRouteLanding();
};
RouteHandler.propTypes = {
    isReactApp: prop_types_1.default.bool,
};
RouteHandler.defaultProps = {
    isReactApp: false,
};
const mapStateToProps = (state) => ({
    context: state.main.context,
});
const mapDispatchToProps = (dispatch) => ({
    setCpParams: (data) => dispatch(reducers_main_reducer_1.actions.setCpParams(data)),
    setContextData: (newData) => dispatch(reducers_main_reducer_1.actions.setContextData(newData)),
    checkCPAndSetZones: (data) => dispatch(reducers_main_reducer_1.actions.checkCPAndSetZones(data)),
    setUserPqInfo: (data) => dispatch(reducers_main_reducer_1.actions.setUserPqInfo(data)),
    setUserLgInfo: (data) => dispatch(reducers_main_reducer_1.actions.setUserLgInfo(data)),
    setUserRecom: (data) => dispatch(reducers_main_reducer_1.actions.setUserRecom(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(RouteHandler);
//# sourceMappingURL=index.js.map